<script>
    export let saveFunction

    function saveOnEnter(evt) {
        if(evt.key === 'Enter') {
            saveFunction()
        }
    }
</script>

<svelte:window on:keydown={saveOnEnter}/>